export class LineClass {
  constructor(l, r, h, key) {
		this.xL=l;
		this.xR=r;
		this.y=h;
		this.id=key;
  }
}


// WEBPACK FOOTER //
// src/classes/LineClass.js